// extracted by mini-css-extract-plugin
export default {"searchResultBlock":"SearchResultBlock_searchResultBlock__6MKo7","resultDate":"SearchResultBlock_resultDate__RJ-zp","resultTitle":"SearchResultBlock_resultTitle__cS2HF"};